/**
 * @generated SignedSource<<2df1dced5395a8432ae6cfae11bd01fb>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
export enum RecentFilter {
  ALL = "ALL",
  COLLABORATED_ON = "COLLABORATED_ON",
  CREATED = "CREATED",
  WORKED_ON = "WORKED_ON",
}
export type useRecentPreferencesHomeRecentUserPreferencesMutation_updateUserPreferences_UserPreferences =
  {
    __typename?: "UserPreferences";
    recentFilter: RecentFilter;
  };
export type useRecentPreferencesHomeRecentUserPreferencesMutation_Mutation = {
  __typename?: "Mutation";
  updateUserPreferences: useRecentPreferencesHomeRecentUserPreferencesMutation_updateUserPreferences_UserPreferences;
};
export type useRecentPreferencesHomeRecentUserPreferencesMutationVariables =
  Exact<{
    filter?: InputMaybe<RecentFilter>;
  }>;
export type useRecentPreferencesHomeRecentUserPreferencesMutation =
  useRecentPreferencesHomeRecentUserPreferencesMutation_Mutation;
